import CreateStory from './create-story.redux';

export default CreateStory;
